<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
  <div class="dialog-title">{{'modules.clients.associations.buildingDialog.title.common' | translate}}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="dialog-content scrollable">
  <form [formGroup]="garageRowForm" class="dialog-form scroll-content-padding df-c gap20" autocomplete="off">
    <div class="df gap20">
      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
        <mat-label>{{'modules.clients.associations.garageRow.labels.type' | translate}}</mat-label>
        <mat-select class="select-panel" panelClass="dialog-select-panel" disableOptionCentering="true" formControlName="type">
          <mat-option [value]="'LINE'">
            {{'modules.clients.associations.garageRow.types.LINE' | translate}}
          </mat-option>
          <mat-option [value]="'ROW'">
            {{'modules.clients.associations.garageRow.types.ROW' | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 150px; min-width: 150px; max-width: 150px;">
        <mat-label>{{'modules.clients.associations.garageRow.labels.number' | translate}}</mat-label>
        <input type="text" matInput formControlName="number" autocomplete="chrome-off">
      </mat-form-field>
    </div>
  </form>
</div>
<div class="buttons-row df jc-e ai-c">
  <button class="default-button apply-button" [disabled]="garageRowForm.invalid" (click)="submitForm()">
    {{'common.save' | translate}}
  </button>
</div>
